/**
 * Updates the SimpleBar instance for a given list element.
 *
 * @param {HTMLElement} list - The list element to update.
 */
function updateSimpleBar(list) {
  if (list.SimpleBar) {
    list.SimpleBar.unMount();
  }
  list.SimpleBar = new SimpleBar(list);

  const simplebarYInstancesArr = list.querySelectorAll(
    '.simplebar-track.simplebar-vertical'
  );
  const simplebarXInstancesArr = list.querySelectorAll(
    '.simplebar-track.simplebar-horizontal'
  );

  if (simplebarYInstancesArr.length) {
    simplebarYInstancesArr.forEach((element, idx) => {
      if (idx > 0) {
        element.remove();
      }
    });
  }

  if (simplebarXInstancesArr.length) {
    simplebarXInstancesArr.forEach((element, idx) => {
      if (idx > 0) {
        element.remove();
      }
    });
  }
}

/**
 * Initializes  meta select elements and sets up the list dropdown functionality.
 *
 * @param {string} elementsArr - The CSS selector to find the select elements.
 */
window.initMetaSelect = function initMetaSelect(elementsArr) {
  const metaSelectArr = document.querySelectorAll(elementsArr);

  metaSelectArr.forEach((selectElement, idx) => {
    const parentContainer = selectElement.closest('.meta-select');
    parentContainer.style.zIndex = metaSelectArr.length - idx;

    if (!parentContainer) return;

    if (!selectElement.classList.contains('is-init')) {
      selectElement.classList.add('is-init');

      const label = parentContainer.querySelector('label');

      const wrapper = document.createElement('div');
      wrapper.className = 'meta-select-inner';

      const placeholder = document.createElement('div');
      placeholder.className = 'meta-select-placeholder';

      const list = document.createElement('div');
      list.className = 'meta-select-list';

      const notInlinePosition = selectElement.hasAttribute(
        'data-meta-select-not-inline'
      );

      let firstCall = true;

      /**
       * Positions the dropdown list relative to the select element.
       */
      function positionList() {
        if (!notInlinePosition) return;

        document.body.appendChild(list);
        list.style.position = 'absolute';
        list.style.minWidth = `${wrapper.clientWidth}px`;
        list.style.maxWidth = `${wrapper.clientWidth}px`;

        const selectRect = wrapper.getBoundingClientRect();
        const scrollTop = window.scrollY || document.documentElement.scrollTop;

        let top = selectRect.top + scrollTop + wrapper.clientHeight + 3;
        let left = selectRect.left;

        list.style.top = `${top}px`;
        list.style.left = `${left}px`;
      }

      /**
       * Updates the dropdown list with the current options from the select element.
       */
      function updateList() {
        list.innerHTML = '';
        placeholder.textContent =
          selectElement.options[selectElement.selectedIndex]?.text ||
          'Selected...';

        Array.from(selectElement.options).forEach((option) => {
          const item = document.createElement('div');
          item.className = 'meta-select-list__item';
          item.textContent = option.text;
          item.dataset.value = option.value;

          if (option.selected) {
            item.classList.add('is-selected');
          }

          if (option.disabled) {
            item.classList.add('is-disabled');
          }

          if (option.classList.contains('is-placeholder')) {
            item.classList.add('is-placeholder');
          }

          item.addEventListener('click', () => {
            if (!item.classList.contains('is-disabled')) {
              setMetaSelectValue(selectElement.id, option.value);
              closeList();
            }
          });

          list.appendChild(item);
        });

        setTimeout(function () {
          positionList();
        }, 50);
        updateSimpleBar(list);
      }

      /**
       * Opens the dropdown list and positions it correctly.
       */
      function openList() {
        list.classList.add('is-open');
        wrapper.classList.add('is-open');
        positionList();
        // window.addEventListener('resize', positionList);
        updateSimpleBar(list);
        setTimeout(function () {
          positionList();
        }, 0);
      }

      /**
       * Closes the dropdown list and removes event listeners.
       */
      function closeList() {
        list.classList.remove('is-open');
        wrapper.classList.remove('is-open');
        // window.removeEventListener('resize', positionList);

        if (notInlinePosition) {
          wrapper.appendChild(list);
        }
      }

      /*if (notInlinePosition) {
        const scrollContainer = selectElement.closest(
          '.container-scroll'
        );
        if (scrollContainer) {
          scrollContainer.addEventListener('scroll', closeList);
          scrollContainer.addEventListener('touchmove', closeList);
        }
      }*/

      /**
       * Toggles the visibility of the dropdown list.
       */
      const toggleList = () => {
        if (list.classList.contains('is-open')) {
          closeList();
        } else {
          openList();
        }
      };

      wrapper.addEventListener('click', (ev) => {
        if (ev.target !== list && ev.target !== label) {
          toggleList();
        }
      });

      label?.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        toggleList();
      });

      document.addEventListener('click', (e) => {
        if (
          !wrapper.contains(e.target) &&
          !list.contains(e.target) &&
          (!label || !label.contains(e.target))
        ) {
          closeList();
        }
      });

      selectElement.addEventListener('change', updateList);

      wrapper.appendChild(placeholder);
      wrapper.appendChild(list);
      parentContainer.appendChild(wrapper);
      selectElement.style.display = 'none';

      updateList();
    }
  });
};

/**
 * Sets the value of a select element and triggers a change event.
 *
 * @param {string} selectId - The ID of the select element.
 * @param {string} value - The value to set for the select element.
 */
window.setMetaSelectValue = function setMetaSelectValue(selectId, value) {
  const selectElement = document.getElementById(selectId);
  if (!selectElement) return;

  const optionExists = Array.from(selectElement.options).some(
    (option) => option.value === value
  );
  if (!optionExists) return;

  selectElement.value = value;
  selectElement.dispatchEvent(new Event('change', { bubbles: true }));
};

/**
 * Updates the dropdown list of a specific select element.
 *
 * @param {string} selectId - The ID of the select element to update.
 */
window.updateMetaSelect = function updateMetaSelect(selectId) {
  const selectElement = document.getElementById(selectId);
  if (!selectElement) return;

  const parentContainer = selectElement.closest('.meta-select');
  if (!parentContainer) return;

  const wrapper = parentContainer.querySelector('.meta-select-inner');
  const placeholder = wrapper.querySelector('.meta-select-placeholder');
  const list = wrapper.querySelector('.meta-select-list');

  if (!list) return;

  list.innerHTML = '';
  Array.from(selectElement.options).forEach((option) => {
    const item = document.createElement('div');
    item.className = 'meta-select-list__item';
    item.textContent = option.text;
    item.dataset.value = option.value;

    if (option.selected) {
      item.classList.add('is-selected');
    }

    if (option.disabled) {
      item.classList.add('is-disabled');
    }

    if (option.classList.contains('is-placeholder')) {
      item.classList.add('is-placeholder');
    }

    item.addEventListener('click', () => {
      if (!item.classList.contains('is-disabled')) {
        setMetaSelectValue(selectId, option.value);
        list.classList.remove('is-open');
        wrapper.classList.remove('is-open');
      }
    });

    list.appendChild(item);
  });

  placeholder.textContent =
    selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';

  updateSimpleBar(list);
};

/**
 * Updates the dropdown list of all select elements on the page.
 */
window.updateAllMetaSelects = function updateAllMetaSelects() {
  document.querySelectorAll('[data-meta-select]').forEach((selectElement) => {
    const parentContainer = selectElement.closest('.meta-select');
    if (!parentContainer) return;

    const wrapper = parentContainer.querySelector('.meta-select-inner');
    const placeholder = wrapper.querySelector('.meta-select-placeholder');
    const list = wrapper.querySelector('.meta-select-list');

    if (!list) return;

    list.innerHTML = '';
    Array.from(selectElement.options).forEach((option) => {
      const item = document.createElement('div');
      item.className = 'meta-select-list__item';
      item.textContent = option.text;
      item.dataset.value = option.value;

      if (option.selected) {
        item.classList.add('is-selected');
      }

      item.addEventListener('click', () => {
        setMetaSelectValue(selectElement.id, option.value);
        list.classList.remove('is-open');
        wrapper.classList.remove('is-open');
      });

      list.appendChild(item);
    });

    placeholder.textContent =
      selectElement.options[selectElement.selectedIndex]?.text || 'Selected...';

    updateSimpleBar(list);
  });
};

initMetaSelect('[data-meta-select]');
